import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const TemplateBackgroundImageScaleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplateBackgroundImageScale"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"backgroundImageScaled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"TemplateBackgroundImageScale","document":TemplateBackgroundImageScaleDocument}} as const;
export type TemplateBackgroundImageScaleQueryVariables = Types.Exact<{
  idBoard: Types.Scalars['ID']['input'];
}>;


export type TemplateBackgroundImageScaleQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id'>
    & { prefs?: Types.Maybe<(
      { __typename: 'Board_Prefs' }
      & { backgroundImageScaled?: Types.Maybe<Array<(
        { __typename: 'Board_Prefs_BackgroundImageScaled' }
        & Pick<Types.Board_Prefs_BackgroundImageScaled, 'height' | 'url' | 'width'>
      )>> }
    )> }
  )> }
);

/**
 * __useTemplateBackgroundImageScaleQuery__
 *
 * To run a query within a React component, call `useTemplateBackgroundImageScaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateBackgroundImageScaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateBackgroundImageScaleQuery({
 *   variables: {
 *      idBoard: // value for 'idBoard'
 *   },
 * });
 */
export function useTemplateBackgroundImageScaleQuery(
  baseOptions: TrelloQueryHookOptions<
    TemplateBackgroundImageScaleQuery,
    TemplateBackgroundImageScaleQueryVariables
  > &
    (
      | {
          variables: TemplateBackgroundImageScaleQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: TemplateBackgroundImageScaleDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    TemplateBackgroundImageScaleQuery,
    TemplateBackgroundImageScaleQueryVariables
  >(TemplateBackgroundImageScaleDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useTemplateBackgroundImageScaleLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    TemplateBackgroundImageScaleQuery,
    TemplateBackgroundImageScaleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TemplateBackgroundImageScaleQuery,
    TemplateBackgroundImageScaleQueryVariables
  >(TemplateBackgroundImageScaleDocument, options);
}
export function useTemplateBackgroundImageScaleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        TemplateBackgroundImageScaleQuery,
        TemplateBackgroundImageScaleQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TemplateBackgroundImageScaleQuery,
    TemplateBackgroundImageScaleQueryVariables
  >(TemplateBackgroundImageScaleDocument, options);
}
export type TemplateBackgroundImageScaleQueryHookResult = ReturnType<
  typeof useTemplateBackgroundImageScaleQuery
>;
export type TemplateBackgroundImageScaleLazyQueryHookResult = ReturnType<
  typeof useTemplateBackgroundImageScaleLazyQuery
>;
export type TemplateBackgroundImageScaleSuspenseQueryHookResult = ReturnType<
  typeof useTemplateBackgroundImageScaleSuspenseQuery
>;
export type TemplateBackgroundImageScaleQueryResult = Apollo.QueryResult<
  TemplateBackgroundImageScaleQuery,
  TemplateBackgroundImageScaleQueryVariables
>;
